import React from 'react'
import { SimpleGrid, Text, Container, VStack, Button } from "@chakra-ui/react";
import { useProduct } from '../../providers/ProductProvider';
import ProductCard from '../common/ProductCard';
import { Link } from 'react-router-dom';

export default function PopularProducts() {

    const { popularProduct } = useProduct();

    return (
        <>
            <Container maxW='8xl'>
                <VStack w='100%' spacing='4'>

                    <Text as='h1' className='customfont' fontSize={[24, 28, 28, 30, 32]}>Most Loved ♥</Text>
                    <Text>Most Loved Products from our collection.</Text>

                    <SimpleGrid w='100%' columns={[2, 2, 3, 4]} spacing={[4, 4, 6, 8]}>
                        {popularProduct.map((p, index) => {
                            return <ProductCard key={index} product={p} />
                        })}
                    </SimpleGrid>

                    <Link to='/shop'>
                        <Button bg='#1c1c1c' _hover={{ bg: '#1d1d1d' }} color="#fefefe" py='6'  >View All</Button>
                    </Link>
                </VStack>
            </Container >
        </>
    )
}
